module.exports = __webpack_public_path__ + "img/Slide46.3fedaa2c.png";